import { render, staticRenderFns } from "./Pedidos.vue?vue&type=template&id=7b37cd09&scoped=true"
import script from "./Pedidos.vue?vue&type=script&lang=js"
export * from "./Pedidos.vue?vue&type=script&lang=js"
import style0 from "./Pedidos.vue?vue&type=style&index=0&id=7b37cd09&prod&lang=css"
import style1 from "./Pedidos.vue?vue&type=style&index=1&id=7b37cd09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b37cd09",
  null
  
)

export default component.exports